module.exports = __webpack_public_path__ + "static/img/jigou-henanzhongyuan-top.cf5f3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-henanzhongyuan-top.png
// module id = 253j
// module chunks = 2